export var createIsSecureContext = function createIsSecureContext(window) {
  return window !== null && window.isSecureContext;
};